import { render } from "./GalaxyView.vue?vue&type=template&id=51327e0c"
import script from "./GalaxyView.vue?vue&type=script&lang=js"
export * from "./GalaxyView.vue?vue&type=script&lang=js"
script.render = render

export default script